import script from "./PersonData.vue?vue&type=script&setup=true&lang=js"
export * from "./PersonData.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__